import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { siteInfo } from '@/mocks/siteInfo';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setCategoryOpen(false);
  }, [location.pathname]);

  const navBg = isHome && !scrolled
    ? 'bg-transparent'
    : 'bg-background-50/95 backdrop-blur-md';

  const textColor = isHome && !scrolled
    ? 'text-white'
    : 'text-foreground-800';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${navBg} ${scrolled ? 'border-b border-background-200/70' : ''}`}
    >
      <nav className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16 md:h-18" aria-label="主导航">
        <Link to="/" className={`text-2xl font-semibold font-heading ${textColor} hover:opacity-80 transition-opacity whitespace-nowrap`}>
          {siteInfo.name}
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <Link to="/" className={`${textColor}/80 hover:${textColor} transition-colors text-sm font-medium whitespace-nowrap`}>
            首页
          </Link>

          <div
            className="relative"
            onMouseEnter={() => setCategoryOpen(true)}
            onMouseLeave={() => setCategoryOpen(false)}
          >
            <button
              className={`flex items-center gap-1 ${textColor}/80 hover:${textColor} transition-colors text-sm font-medium whitespace-nowrap cursor-pointer`}
            >
              攻略分类
              <i className={`ri-arrow-down-s-line text-xs transition-transform ${categoryOpen ? 'rotate-180' : ''}`}></i>
            </button>
            {categoryOpen && (
              <div className="absolute top-full left-1/2 -translate-x-1/2 pt-3">
                <div className="bg-background-50 rounded-lg border border-background-200/70 py-2 px-1 min-w-[200px] shadow-lg">
                  {categories.map((cat) => (
                    <Link
                      key={cat.id}
                      to={`/category/${cat.slug}`}
                      className="flex items-center gap-3 px-4 py-2.5 hover:bg-primary-50 rounded-md transition-colors group whitespace-nowrap"
                    >
                      <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                        <i className={`${cat.icon} text-sm`}></i>
                      </span>
                      <span className="text-foreground-700 text-sm">{cat.name}</span>
                    </Link>
                  ))}
                </div>
              </div>
            )}
          </div>

          <Link to="/about" className={`${textColor}/80 hover:${textColor} transition-colors text-sm font-medium whitespace-nowrap`}>
            关于我们
          </Link>
        </div>

        <button
          className={`md:hidden w-10 h-10 flex items-center justify-center ${textColor} cursor-pointer`}
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="切换菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-1">
            <Link to="/" className="px-4 py-3 text-foreground-700 hover:bg-background-100 rounded-lg text-sm font-medium">
              首页
            </Link>
            <div className="px-4 py-2 text-foreground-500 text-xs font-medium uppercase tracking-wider">
              攻略分类
            </div>
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className="flex items-center gap-3 px-4 py-3 hover:bg-background-100 rounded-lg text-sm"
              >
                <span className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className={`${cat.icon} text-xs`}></i>
                </span>
                <span className="text-foreground-700">{cat.name}</span>
              </Link>
            ))}
            <Link to="/about" className="px-4 py-3 text-foreground-700 hover:bg-background-100 rounded-lg text-sm font-medium">
              关于我们
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}